import { cn } from '@/lib/utils'
import { AmericanFootballIcon, BaseballIcon, BasketballIcon, BoxingIcon, FootballIcon, HockeyIcon, TennisIcon, VideoIcon, VolleyballIcon } from './sport-icons'
import { MatchCard, type Match } from './MatchCard'

const CATEGORIES = [
	{ label: 'Live', icon: VideoIcon, active: true },
	{ label: 'Soccer', icon: FootballIcon },
	{ label: 'Football', icon: AmericanFootballIcon },
	{ label: 'Boxing', icon: BoxingIcon },
	{ label: 'Volleyball', icon: VolleyballIcon },
	{ label: 'Tennis', icon: TennisIcon },
	{ label: 'Basketball', icon: BasketballIcon },
	{ label: 'Hockey', icon: HockeyIcon },
	{ label: 'Baseball', icon: BaseballIcon },
]

const MATCHES: Match[] = [
	{
		league: 'Premier League',
		country: 'England',
		teamA: {
			name: 'Chelsea',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/e498cc664a9a82fd801e0abcc5440c6ec2db706b?width=80',
		},
		teamB: {
			name: 'Manchester United',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/694eb73533c293a67afeadbfa82110397c971d57?width=80',
		},
		odds: [
			{ label: '1', value: '44.5' },
			{ label: 'X', value: '44.5' },
			{ label: '2', value: '44.5' },
		],
		banner: 'https://api.builder.io/api/v1/image/assets/TEMP/f358c97e5b89bdffab7867547bcf30be7548952e?width=738',
	},
	{
		league: 'Nepal Prime Minister Cup',
		country: 'Nepal',
		teamA: {
			name: 'Fritz, Taylor',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/64585d4fce8531229f40e05d2335799e3a7c014d?width=80',
		},
		teamB: {
			name: 'Medjedovic, Hamad',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/350d0bd933ed0e1f86dc0e992b0535ba8b36f0ee?width=80',
		},
		odds: [
			{ label: '1', value: '44.5' },
			{ label: 'X', value: '44.5' },
			{ label: '2', value: '44.5' },
		],
		banner: 'https://api.builder.io/api/v1/image/assets/TEMP/0b72c8bb21bf3afcd3971f1db459379ab3a535c9?width=738',
	},
	{
		league: 'Nepal Prime Minister Cup',
		country: 'Nepal',
		teamA: {
			name: 'Czech Republic',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/e091ad4c4e872391aa4fca8c489395274a499674?width=80',
		},
		teamB: {
			name: 'Norway',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/9b97a5b4d3e84f4800957700c9869bd9b40c600a?width=80',
		},
		odds: [
			{ label: '1', value: '44.5' },
			{ label: 'X', value: '44.5' },
			{ label: '2', value: '44.5' },
		],
		banner: 'https://api.builder.io/api/v1/image/assets/TEMP/ead3b251f30fb1b0bd064099be7ad13ff9cace58?width=738',
	},
	{
		league: 'Serie A',
		country: 'Italy',
		teamA: {
			name: 'Brescia',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/780bbc44c71d03f7bbc8ec90d21d10a891b4e75a?width=80',
		},
		teamB: {
			name: 'Treste',
			image: 'https://api.builder.io/api/v1/image/assets/TEMP/9b97a5b4d3e84f4800957700c9869bd9b40c600a?width=80',
		},
		odds: [
			{ label: '1', value: '44.5' },
			{ label: 'X', value: '44.5' },
		],
		banner: 'https://api.builder.io/api/v1/image/assets/TEMP/05a8df2fd2ba2c775bc3ba4b0b3aa66895a58cac?width=738',
	},
]

export function SportsbookSection() {
	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center justify-between'>
				<div className='flex items-center gap-3'>
					<FootballIcon className='h-7 w-7 text-subtle-foreground' />
					<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Sportsbook</h2>
				</div>
				<button type='button' className='rounded-xl border border-border bg-card px-6 py-3 text-sm font-semibold tracking-[-0.21px] text-foreground'>
					All sports
				</button>
			</div>

			<div className='flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
				{CATEGORIES.map(({ label, icon: Icon, active }) => (
					<button
						key={label}
						type='button'
						className={cn(
							'flex shrink-0 items-center gap-2 rounded-lg border border-border bg-secondary px-3.5 py-2.5 text-base font-medium tracking-[-0.24px]',
							active ? 'text-foreground' : 'text-muted-foreground',
						)}
					>
						<Icon className='h-6 w-6' />
						{label}
					</button>
				))}
			</div>

			<div className='flex gap-4 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
				{MATCHES.map((match, i) => (
					<MatchCard key={i} match={match} />
				))}
			</div>
		</section>
	)
}
